/// A Meta recusa o MP4/WebM do navegador ("131053: Media upload error"): exige OGG com Opus, mono.
/// A conversão roda aqui para o servidor não depender de nada instalado.
export const VOICE_NOTE_TYPE = 'audio/ogg';

const OPUS = { codec: 'opus', numberOfChannels: 1, sampleRate: 48000 } as const;

/// Sem codificação Opus a gravação fica escondida; WebCodecs responde sem carregar a biblioteca.
export const canMakeVoiceNote = async (): Promise<boolean> => {
    if (typeof window === 'undefined' || !('AudioEncoder' in window)) return false;

    const { supported } = await AudioEncoder.isConfigSupported(OPUS);
    return Boolean(supported);
};

/// Converte a gravação do MediaRecorder; o Opus do WebM é recodificado só para virar mono.
export async function toVoiceNote(recording: Blob): Promise<Blob> {
    const {
        BlobSource, BufferTarget, Conversion, Input, MP4, OGG, OggOutputFormat, Output, WEBM,
    } = await import('mediabunny');

    const target = new BufferTarget();

    const input = new Input({ formats: [WEBM, OGG, MP4], source: new BlobSource(recording) });
    const output = new Output({ format: new OggOutputFormat(), target });

    const conversion = await Conversion.init({
        input,
        output,
        audio: { codec: OPUS.codec, numberOfChannels: OPUS.numberOfChannels, sampleRate: OPUS.sampleRate },
    });

    if (!conversion.isValid) {
        const reasons = conversion.discardedTracks.map((track) => track.reason).join(', ');
        throw new Error(`gravação sem áudio aproveitável (${reasons || 'desconhecido'})`);
    }

    await conversion.execute();

    return new Blob([target.buffer!], { type: VOICE_NOTE_TYPE });
}
